<template>
  <div id="design-report">
    <header class="justify-content-center pt-4 flex-column align-items-center">
      <div>
        <!-- <SpinnerButton
          :loading="!pdfUrl"
          variant="primary"
          class="ma-auto"
          :href="pdfUrl"
        >
          Download PDF
        </SpinnerButton> -->
        <b-btn
          variant="primary"
          @click="printPage"
        >
          Print Summary
        </b-btn>
      </div>
    </header>

    <design-page
      v-for="(door, index) in doors"
      :product="door"
      :key="index"
      :layer="door.layer"
      :isLast="index === doors.length - 1 && !projectImg"
    />
    <design-page
      v-if="projectImg"
      :product="projectImgObject"
      :isLast="true"
      pageName="Project Summary"
    />
  </div>
</template>

<script>
import axios from 'axios';
import DesignPage from '@/components/designReport/DesignPage';
import SpinnerButton from '@/components/utility/SpinnerButton';

export default {
  name: 'design-report',
  data() {
    return {
      doors: [],
      projectImg: null,
      pdfUrl: undefined,
    };
  },
  computed: {
    projectImgObject() {
      return { shareImgPath: this.projectImg };
    },
  },
  methods: {
    async fetchSharedData(id) {
      const renderRegex = /product\/render\/.+\.jpg$/;
      const doorFormattedForRender = (door) => {
        const shareImgPath = door.shareImgPath ?
          `${window.Renoworks.Util.getBaseApiUrl()}${door.shareImgPath}` :
          door.renderedImage.replace(renderRegex, `projects/shared/${id}/render.jpg`);
        door.shareImgPath = shareImgPath;
        return door;
      };

      return axios.get(`${window.Renoworks.Util.getBaseApiUrl()}/Share?id=${id}`)
        .then(({ data }) => {
          if (!data) {
            throw new Error(`Request: ${window.Renoworks.Util.getBaseApiUrl()}/Share?id=${id} returned no data`);
          }
          const { project, doors } = data;

          this.projectImg = project && project.shareImgPath &&
            `${window.Renoworks.Util.getBaseApiUrl()}${project.shareImgPath}`;

          doors
            .map(doorFormattedForRender)
            .forEach(door => this.doors.push(door));
        });
    },
    printPage() {
      window.print();
    },
  },
  async created() {
    const { id } = this.$route.query;
    if (id) {
      this.pdfUrl = `${window.Renoworks.Util.getBaseApiUrl()}/DesignToPdf?${window.jQuery.param({
        site: 'CHI',
        json: JSON.stringify({ designID: id }),
      })}`;

      await this.fetchSharedData(id);
    } else {
      // eslint-disable-next-line no-console
      console.error('Design report query requires an id parameter');
    }
  },
  components: {
    DesignPage,
    SpinnerButton,
  },
};
</script>

<style lang="scss">
#design-report {
  // @HACK: PDF generator doesn't support media queries, so this hides the header from it's output
  > header {
    display: none;

    @media not print {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designReport/DesignReport.vue